import React, { Component, ReactNode } from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
}
interface ErrorBoundaryProp{
    children?: ReactNode;
}
export default class ErrorBoundary extends Component<ErrorBoundaryProp, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    //   logErrorToMyService(error, info);
    // tslint:disable-next-line:no-console
    console.log(`error: `, error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }
    return <>{this.props.children}</>;
  }
}
